import React from 'react';
import styled, { css } from 'styled-components';
import { Button } from '@sparknz/spark-pattern-library';
import { LinkRegion, trackCustomLink } from '@sparknz/tracking';

import useAddBundles from 'components/shop/MobilePlans/hooks/useAddBundles';
import { useSelectedPlans } from '../../providers';
import { MobilePlansDetails } from '../../typings/plans';
import { buildAddBundlesInputBundles } from '../../utils/buildAddBundlesInputBundles';

const BottomBarActionsContainer = styled.div`
  ${({ theme: { media, spacing } }) => css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: ${spacing.s2};
    padding-top: ${spacing.s2};

    & > div {
      flex-basis: 100%;
    }

    ${media.up('slim')} {
      padding-top: 0;
      padding-left: ${spacing.s2};
    }
  `}
`;

interface BottomBarActionsProps {
  disabled?: boolean;
  openMpdSelectionActionLayer: () => void;
  planCardsProducts: MobilePlansDetails;
}

export default function BottomBarActions({
  disabled = false,
  openMpdSelectionActionLayer,
  planCardsProducts,
}: BottomBarActionsProps) {
  const { addBundles, isAddingBundles } = useAddBundles();
  const { selectedPlans } = useSelectedPlans();

  function handleViewSelectionClick() {
    trackCustomLink('Select plan');
    openMpdSelectionActionLayer();
  }

  async function handleAddCartClick() {
    trackCustomLink('Select plan');
    const bundles = buildAddBundlesInputBundles({ selectedPlans });
    await addBundles({ bundles, planCardsProducts });
  }

  return (
    <BottomBarActionsContainer>
      <LinkRegion regionId="planSelectionSummary">
        <Button
          variant="default"
          disabled={disabled}
          onClick={handleViewSelectionClick}
        >
          View selection
        </Button>
      </LinkRegion>
      <LinkRegion regionId="selectedPlansActionLayer">
        <Button
          variant="primary"
          disabled={disabled}
          onClick={handleAddCartClick}
          isLoading={isAddingBundles}
        >
          Add to cart
        </Button>
      </LinkRegion>
    </BottomBarActionsContainer>
  );
}
